"use strict";
exports.__esModule = true;
exports.SourceOptions = void 0;
var SourceOptions;
(function (SourceOptions) {
    SourceOptions["UI"] = "CRM ui";
})(SourceOptions = exports.SourceOptions || (exports.SourceOptions = {}));
